import styled from 'styled-components';

export const Wrapper = styled.div`
  cursor: pointer;
  position: relative;
  width: 20px;
  height: 14px;
`;

export const FirstCrossPart = styled.span`
  background-color: ${(props) => (props.opened ? props.theme.secondary8Color : '#000')};
  position: absolute;
  top: 5px;
  left: 0;
  width: 20px;
  height: 2px;
  transform: rotateZ(45deg);
`;

export const SecondCrossPart = styled.span`
  background-color: ${(props) => (props.opened ? props.theme.secondary8Color : '#000')};
  position: absolute;
  top: 40%;
  left: 0;
  width: 20px;
  height: 2px;
  transform: rotateZ(-45deg);
`;
